import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    htmlFontSize: 11,
    fontFamily: 'Poppins, sans-serif',
  },
  palette: {},
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': ['Poppins'],
      },
    },
    MuiButton: {
      text: {
        color: 'white',
      },
    },
  },
});

export default responsiveFontSizes(theme);
